import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { SnotifyService } from 'ng-snotify';
import { SpinnerService } from '../_core/spinner/spinner.service';
import { ActivatedRoute } from '@angular/router';
import { AddressDataForm } from '../_models/address-data-form';
import { MyErrorStateMatcher } from '../register/register.component';
/// <reference types="@types/googlemaps"/>
import { MapsAPILoader } from '@agm/core';
import { WhiteSpaceValidators } from '../shared/whitespace.validator';
import { UserDataService } from '../_services/user-data.service';
import { UserDetailsDataForm } from '../_models/user-details-data-form';
import { OrganizationDataForm } from '../_models/organization-data-form';
declare var google: any;

@Component({
  selector: 'app-my-account',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})

export class AddressComponent implements OnInit {
  userDetailsId: any;
  addressId: any;
  addressDataForm: AddressDataForm = new AddressDataForm();
  userDetailsDataForm: UserDetailsDataForm = new UserDetailsDataForm();
  organizationDataForm: OrganizationDataForm = new OrganizationDataForm();
  addressDataFormGroup: FormGroup;
  errorMessage: string;
  updateFlag = '';
  userDataSession;
  userDisplayName = '';
  userDisplayFullNAme = '';
  userRoleId = 0;
  mobileNumber = '';
  userSession;
  mobileNumberValidState: boolean = true;

  @ViewChild('autoComplete') public searchElementRef: ElementRef;

  constructor(
    private authService: AuthService,
    private snotifyService: SnotifyService,
    public spinnerService: SpinnerService,
    private formbuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private userDataService: UserDataService 
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.userDetailsId = params['id'];
      this.updateFlag = 'true';
    });
  }

  ngOnInit() {
    this.addressDataFormValidate();
    this.userDataSession = this.authService.getUserData();
    if (this.updateFlag == 'true' && this.userDetailsId > 0) {
      this.activatedRoute.data.subscribe(
        data => {
          const resolvedData: UserDetailsDataForm = data['resolvedData'];
          this.displayUserDetails(resolvedData);
        }
      )
    }

    //===== Auto complete =====
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["establishment"]
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place = autocomplete.getPlace();
          this.addressDataFormGroup.get('organization').setValue(place.name);
          this.addressDataFormGroup.get('address1').setValue(place.formatted_address);
          this.userDetailsDataForm.organizationDetails.organizationName = place.name;
          this.userDetailsDataForm.organizationDetails.addressLineOne = place.formatted_address;
          this.userDetailsDataForm.organizationDetails.webSite = place.website;
          this.userDetailsDataForm.organizationDetails.phoneNumber = place.international_phone_number;
          for (let i in place.address_components) {
            const exactType = place.address_components[i].types[0];
            if (exactType == 'sublocality_level_1') {
              this.addressDataFormGroup.get('address2').setValue(place.address_components[i].long_name);
            }
            if (exactType == 'locality') {
              this.addressDataFormGroup.get('city').setValue(place.address_components[i].long_name);
            }
            if (exactType == 'administrative_area_level_1') {
              this.addressDataFormGroup.get('state').setValue(place.address_components[i].long_name);
            }
            if (exactType == 'country') {
              this.addressDataFormGroup.get('country').setValue(place.address_components[i].long_name);
            }
            if (exactType == 'postal_code') {
              this.addressDataFormGroup.get('zip').setValue(place.address_components[i].long_name);
            }
          }
        });
      });
    });
  }


  displayUserDetails(userDetailsDataForm: UserDetailsDataForm): void {
    if (this.addressDataFormGroup) {
      this.addressDataFormGroup.reset();
    }
    this.userDetailsDataForm = userDetailsDataForm;

    // Update the data on the form
    this.addressDataFormGroup.patchValue({
      firstName: this.userDetailsDataForm.firstName,
      lastName: this.userDetailsDataForm.lastName,
      email: this.userDetailsDataForm.userName,
      mobileNo: this.userDetailsDataForm.mobileNo,
      designation: this.userDetailsDataForm.designation,
      organization: this.userDetailsDataForm.organizationDetails.organizationName,
      address1: this.userDetailsDataForm.organizationDetails.addressLineOne,
      address2: this.userDetailsDataForm.organizationDetails.addressLineTwo,
      city: this.userDetailsDataForm.organizationDetails.city,
      state: this.userDetailsDataForm.organizationDetails.state,
      country: this.userDetailsDataForm.organizationDetails.countryName,
      zip: this.userDetailsDataForm.organizationDetails.zipCode,
    });
  }
  addressDataFormValidate() {
    const mobnumPattern = "^[0-9+]*$";
    const namePattern = "^[A-Za-z\\s-]+$";
    this.addressDataFormGroup = this.formbuilder.group({
      firstName: ['', [Validators.required, Validators.pattern(namePattern), WhiteSpaceValidators.emptySpace()]],
      lastName: ['', [Validators.required, Validators.pattern(namePattern), WhiteSpaceValidators.emptySpace()]],
      mobileNo: ['', [Validators.required, Validators.pattern(mobnumPattern)]],
      email: [{ value: '', disabled: true }, [Validators.required]],
      designation: [''],
      organization: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      address1: [''],
      address2: [''],
      city: [''],
      state: [''],
      country: [''],
      zip: [''],
    })
  }

  getNumber(fullPhone: any) {
    this.userDetailsDataForm.mobileNo = fullPhone;
  }

  hasError(errorState: boolean) {
    this.mobileNumberValidState = errorState;
  }
  
  telInputObject(obj) {
    obj.intlTelInput('setNumber', this.userDetailsDataForm.mobileNo);
  }

  saveAddress(): void {
    if (this.addressDataFormGroup.valid && this.mobileNumberValidState == true) {
      if (this.addressDataFormGroup.dirty) {
        this.userDetailsDataForm.firstName = this.addressDataFormGroup.get('firstName').value;
        this.userDetailsDataForm.lastName = this.addressDataFormGroup.get('lastName').value;
        this.userDetailsDataForm.userName = this.addressDataFormGroup.get('email').value;
        this.userDetailsDataForm.mobileNo = this.userDetailsDataForm.mobileNo;
        this.userDetailsDataForm.designation = this.addressDataFormGroup.get('designation').value;
        this.userDetailsDataForm.organizationDetails.organizationName = this.addressDataFormGroup.get('organization').value;
        this.userDetailsDataForm.organizationDetails.addressLineOne = this.addressDataFormGroup.get('address1').value;
        this.userDetailsDataForm.organizationDetails.addressLineTwo = this.addressDataFormGroup.get('address2').value;
        this.userDetailsDataForm.organizationDetails.city = this.addressDataFormGroup.get('city').value;
        this.userDetailsDataForm.organizationDetails.state = this.addressDataFormGroup.get('state').value;
        this.userDetailsDataForm.organizationDetails.countryName = this.addressDataFormGroup.get('country').value;
        this.userDetailsDataForm.organizationDetails.zipCode = this.addressDataFormGroup.get('zip').value;
        this.userDetailsDataForm.userDetailsId = this.userDetailsId;
        //console.log(this.userDetailsDataForm);
        this.userDataService.updateUserDetailsByuserId(this.userDetailsDataForm).subscribe(
          resp => {
            this.snotifyService.success("Your details has been updated successfully")
          }, error => {
            console.log(error);
          })

      }
    }
  }
  matcher = new MyErrorStateMatcher();
}

